import styled from 'styled-components';

const IDWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 14px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  gap: 2px;
  font-size: 10px;
  font-weight: 400;
  line-height: 11.72px;
  color: rgba(117, 117, 117, 1);
  z-index: 1;
`;

const IDNumber = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 11.72px;
  color: #000;
`;

type Props = {
  auction?: { slug: string } | null;
  orderIndex?: number | null;
};

export const AuctionSlugLabel = ({ auction, orderIndex }: Props) => {
  if (!auction) return null;

  const label = auction.slug.replace('-', '') + (orderIndex ? `#${orderIndex}` : '');

  return (
    <IDWrapper>
      <span>ID:</span>
      <IDNumber>{label}</IDNumber>
    </IDWrapper>
  );
};
